import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-circle-badge-count',
  templateUrl: './app-circle-badge-count.html',
  styleUrls: ['./app-circle-badge-count.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CircleBadgeCountComponent implements OnChanges {
  @Input() count: number;
  width: string = '1rem';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.count) {
      this.updateWidth();
    }
  }

  private updateWidth(): void {
    const digitCount = this.count ? this.count.toString().length : 0;

    if (digitCount === 3) {
      this.width = '1.5rem';
    } else if (digitCount > 3) {
      const additionalWidth = 0.3 * (digitCount - 3);
      this.width = `${1.5 + additionalWidth}rem`;
    } else {
      this.width = '1rem'; // Default width for 1-2 digits
    }
  }
}
